import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { CustomerWindowStore, CustomerWindowState } from './customer-window.store';

@Injectable({
    providedIn: 'root'
})
export class CustomerWindowQuery extends QueryEntity<CustomerWindowState> {
    contactId = this.select(state => state.ui.contactId);
    headerTitle = this.select(state => state.ui.headerTitle);


    constructor(protected store: CustomerWindowStore) {
        super(store);
    }
}